<div class="body">
    <img class="preview-image" *ngIf="productPictureData; else placeholderImage" src="{{productPictureData}}" />
    <div class="content">
        <div class="headline">
            {{productNumber}} {{productService}}
        </div>
        <div class="price">
            {{productSetupCost | number:'.2'}}€ Einrichtung
        </div>
        <div class="price">
            {{productPurchaseCost | number:'.2'}}€ Kauf
        </div>
        <div class="price">
            {{productRentalCost | number:'.2'}}€ Miete
        </div>
        <div class="counter" *ngIf="count">
            {{count}} mal im Warenkorb
        </div>
        <div class="control-row">
            <button mat-raised-button class="footer-button" color="accent" (click)="$event.stopPropagation()">
                Details
            </button>
            <button class="footer-button" mat-raised-button color="primary" (click)="$event.stopPropagation()" (click)="addProduct()">
                Warenkorb hinzufügen
            </button>
        </div>
    </div>
</div>
<ng-template #placeholderImage>
    <mat-icon class="placeholder-image">
        image_not_supported
    </mat-icon>
</ng-template>
